// The canonical Dashboard Spec JSON Schema, exposed as an importable object
// (Visual-Dashboards block B1). The single source of truth is the engine file
//   cloud-agent/internal/chat/dashboardspec/schema/flashback.dashboard.v1.schema.json
// mirrored into this package as ./schema.json (byte-identical). esbuild inlines
// this JSON import into the published bundle, so consumers get the schema as a
// plain object — feed it straight to a JSON-Schema validator (e.g. ajv) for full
// client-side spec validation, with no asset loading or fetch.
//
// Note: validate.ts is the cheap, dependency-free pre-check; DASHBOARD_SCHEMA is
// here for callers that want full-fidelity validation against the exact engine
// schema. Both ultimately defer to the engine validator as the safety net.
import schemaJson from './schema.json';

/** The flashback.dashboard/v1 JSON Schema (Draft 2020-12). ajv-ready. */
export const DASHBOARD_SCHEMA: Readonly<Record<string, unknown>> = schemaJson as Record<string, unknown>;
